import React from 'react';
import { Undo2, Home, Files} from 'lucide-react';
import { useNavigate } from 'react-router';

interface BottomNavProps {
  showBack?: boolean;  // Optional prop to show/hide back button
  onSavedClick?: () => void;  // Optional callback for saved button
}

const BottomNav: React.FC<BottomNavProps> = ({ 
  showBack = true,  // Default to showing back button
  onSavedClick 
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleHome = () => {
    navigate('/admin-vehicle-models');
  };

  const handleSaved = () => {
    navigate('/saved-instructions');
    
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg">
      <div className="flex justify-around py-4 max-w-md mx-auto">
        {showBack && (
          <button 
            onClick={handleBack}
            className="flex flex-col items-center"
          >
            <Undo2 className="w-12 h-12 rounded-full p-3  bg-blue-900 hover:font-bold text-white  ransition-transform transform hover:scale-110" />
            <span className="text-xs mt-1 font-bold text-blue-900">Back</span>
          </button>
        )}
        
        <button 
          onClick={handleHome}
          className="flex flex-col items-center"
        >
          <Home className="w-12 h-12 rounded-full p-3  bg-blue-900 hover:font-bold text-white  ransition-transform transform hover:scale-110" />
          <span className="text-xs mt-1 font-bold text-blue-900">Home</span>
        </button>
        
        <button 
          // onClick={handleSaved}
          className="flex flex-col items-center"
        >
          <Files className="w-12 h-12 rounded-full p-3  bg-blue-900 hover:font-bold text-white  ransition-transform transform hover:scale-110" />
          <span className="text-xs mt-1 font-bold text-blue-900">Saved</span>
        </button>
      </div>
    </div>
  );
};

export default BottomNav;